module.exports = __webpack_public_path__ + "img/upperBody.9cf8b44e.svg";